import { render } from "./Target.vue?vue&type=template&id=72398ba0&ts=true"
import script from "./Target.vue?vue&type=script&lang=ts"
export * from "./Target.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__